import React, { createContext, useContext, useEffect, useReducer, useState } from 'react';
import { eventsReducer, EVENTS_ACTIONS } from '../reducers/eventsReducer';
import { useAuthState } from 'react-firebase-hooks/auth';
import {
    getEvents, _createEvent, _updateEvent, _deleteEvent
} from '../services/firebase/events';
import { auth } from '../services/firebase/firebase';
// import { eventos as events } from '../dummy'

const EventsContext = createContext({});

export function useEvents() {
    return useContext(EventsContext)
}

export const EventsContextProvider = ({ children }) => {

    const [user, loading, error] = useAuthState(auth);
    const [state, dispatch] = useReducer(eventsReducer, { events: [] })

    useEffect(() => {
        if (loading) return
        fetchEvents()
    }, [])

    const fetchEvents = async () => {
        const response = await getEvents()
        console.log(response)
        if (response?.status === 'error') return alert(response.msg)
        const data = response.data.map(e => ({...e, date: e.date.toDate()}))
        dispatch({ type: EVENTS_ACTIONS.FETCH_EVENTS, payload: data })
    }


    const createEvent = (event) => {
        return new Promise(async (resolve, reject) => {
            const response = await _createEvent(event)
            if (response?.status === 'error') return alert(response.msg)
            dispatch({ type: EVENTS_ACTIONS.ADD_EVENT, payload: response.data })
            alert(response.msg)
            resolve()
        })
    }

    const updateEvent = async (event) => {
        return new Promise(async (resolve, reject) => {
            let data = event
            const response = await _updateEvent(event.id, data)
            if (response.status === 'error') reject(response.msg)
            dispatch({ type: EVENTS_ACTIONS.UPDATE_EVENT, payload: response.data })
            alert(response.msg)
            resolve(response.msg)
        })
    }

    const deleteEvent = async (id) => {
        return new Promise(async (resolve, reject) => {
            const response = await _deleteEvent(id)
            if (response?.status === 'error') return alert(response.msg)
            dispatch({ type: EVENTS_ACTIONS.DELETE_EVENT, payload: response.data })
            alert(response.msg)
            resolve()
        })
    }

    const value = {
        events: state.events,
        createEvent,
        updateEvent,
        deleteEvent
    }

    return (
        <EventsContext.Provider value={value}>
            {!loading && children}
        </EventsContext.Provider>
    )
}